import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import { IThermoRoomObjectDTO } from '@/../client-generator/generated-clients/plants';

@Options({
  props: {
    roomObject: {
      type: Object as PropType<IThermoRoomObjectDTO>,
      required: true,
    },
    preferenceLabel: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
})
export default class ThermoPreferenceComponent extends Vue {
  roomObject!: IThermoRoomObjectDTO;
}
